module.exports = __webpack_public_path__ + "img/concept-architecture.6dcffe99.svg";